import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"
import $ from "jquery";

export default class PricingController extends React.Component {
    constructor(props) {
        super(props);
        this.customizedProperties = $.extend({}, this.props.customizedProperties);
        this.xhr = null;

        this.state = { quantity: this.props.quantity, price: null };
    }

    componentWillUpdate(nextProps, nextState) {
        const quantity = parseInt(nextProps.quantity, 10);

        if (quantity !== "NaN") {
            const quantityChanged = quantity !== parseInt(nextState.quantity, 10);

            const properties = nextProps.customizedProperties;
            const propertiesChanged = JSON.stringify(properties) !== JSON.stringify(this.customizedProperties);
            if (propertiesChanged) {
                this.customizedProperties = $.extend({}, properties);
            }

            if (properties && propertiesChanged) {
                this.updateInfo(quantity, properties);
            } else if (quantityChanged) {
                if (quantity > 1 || properties) {
                   this.updateInfo(quantity, properties);
                } else {
                    this.setState({quantity: 1, price: null});
                }
            }

        }
    }

    updateInfo(quantity, properties) {
        if (this.xhr) {
            this.xhr.abort();
        }
        this.xhr = $.ajax(this.props.url, {
            method: "POST",
            data: {
                quantity: quantity,
                properties: properties,
            },
            success: data => {
                this.xhr = null;
                this.setState(data)
            },
        });
    }

    render() {
        if (this.state.price === null) {
            return null;
        }

        const PricingView = ComponentRegistry.get(this.props.view);

        return <PricingView {...this.props} {...this.state} />;
    }
}
PricingController.propTypes = {
    quantity: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    view: PropTypes.string.isRequired,
};
PricingController.defaultProps = {
    view: "ProductPurchaseViewsPricingView",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Controllers/PricingController.jsx